import {segment} from './helpers'

export const cancelledAppointment = (daysToAppointment) =>
  segment('Cancelled Appointment', {
    daysToAppointment,
  })

export const clickedBookNewAppointment = (daysToAppointment) =>
  segment('Clicked Book New Appointment', {
    daysToAppointment,
  })

export const clickedCancelInterfaceHtoButton = () => segment('Clicked Cancel Interface HTO Button')

export const cancelAppointmentPageLoaded = (daysToAppointment) =>
  segment('Appointment Cancel Confirmation Page Loaded', {
    daysToAppointment,
  })
